<template>
    <div>
        <rea-loader v-if="loading" :loading="loading" />
        <div v-else class="plain-card">
            <h2>
                <span v-on:click="returnToPreviousPage">
                    <i class="fa fa-chevron-left"></i> {{ uLang('app.feedback') }} |
                </span>
                {{ selectedCoach.full_name }}
            </h2>
            <table>
                <tr>
                    <th>
                        {{ uLang('app.sent_on') }}
                    </th>
                    <th v-for="question in questions" class="text-center">
                        {{ question.question }}
                    </th>
                </tr>
                <tr v-for="feedback in coach_feedback">
                    <td width="15%">{{ feedback.created_at }}</td>
                    <td v-if="feedback.feedback_results === []" colspan="questions.length">
                        {{ uLang('app.no_data') }}
                    </td>
                    <td v-else v-for="result in feedback.feedback_results" class="text-center">
                        <i v-if="result.result === 'true' || result.result === 'false'"
                           class="fa fa-2x"
                           :class="getResultClass(result.result)">
                        </i>
                        <span v-else>{{ result.result }}</span>
                    </td>
                </tr>
                <tr style="font-weight: bold">
                    <td>{{ uLang('app.averages') }}</td>
                    <td class="text-center">{{ Math.round(averages[1] * 100) }}%</td>
                    <td class="text-center">{{ Math.round(averages[2] * 100) }}%</td>
                    <td class="text-center">{{ Math.round(averages[3] * 100) }}%</td>
                    <td class="text-center">{{ Math.round(averages[4] * 10) / 10 }}</td>
                    <td></td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
    import { ReaLoader } from '~/components/helpers'

    export default {
        name: "SelectedCoachFeedback",
        props: {
            coachId: {
                required: true,
            }
        },
        components: {
            'rea-loader': ReaLoader,
        },
        data() {
            return {
                loading: true,
                coach_feedback: [],
                selectedCoach: {},
                questions: [],
                averages: {}
            }
        },
        methods: {
            getResultClass(result) {
                let classes = {
                    'false': 'fa-times text-danger',
                    'true': 'fa-check text-success'
                }

                return classes[result] || ''
            },
            fetchFeedbackPage() {
                window.axios.get(
                    route('coach.getFeedbackPage', { id: this.coachId })
                ).then(({ data }) => {
                    this.selectedCoach = data.coach
                    this.coach_feedback = data.feedback
                    this.questions = data.questions
                    this.averages = data.averages
                }).finally(() => {
                    this.loading = false
                })
            },
            returnToPreviousPage() {
                this.$router.go(-1)
            }
        },
        mounted() {
            this.fetchFeedbackPage()
        }
    }
</script>

<style lang="scss" scoped>
    .plain-card {
        background-color: white;
        padding: 20px;
        position: relative;
        box-shadow: 3px 1px 5px #ccc;

        &:not(:first-child) {
            margin-top: 30px;
        }

        h2 {
            margin-bottom: 20px;
        }

        table {
            width: 100%;

            td, th {
                border: 1px solid black;
                padding: 6px;
                text-align: right;
            }

            tbody {
                th {
                    min-width: 190px;
                }
            }
        }
    }
</style>
